import React, { useContext } from 'react'
import { BookingPageContext } from '@/components/pages/checkout/booking-page/BookingPageContext'
import WrapperElement from '@/components/elements/WrapperElement'
import ErrorSVG from '@/icons/font-awesome/sharp-light/hexagon-exclamation.svg'

export function BookingError() {
  const { saveBookingResponse } = useContext(BookingPageContext)

  return (
    <WrapperElement>
      <div className="flex flex-col items-center justify-center p-5 pt-10">
        <ErrorSVG className="mb-8 mt-1 h-12 w-12 fill-highlight-red" />
      </div>
      <div className="text-start sm:text-center">
        <div className="text-highlight-red">{saveBookingResponse?.StatusText}</div>
      </div>
    </WrapperElement>
  )
}
